export default __webpack_public_path__ + "static/media/Logo_600x200Inverted.87eb70cc.png";